import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "breadcrumb mb-0" };
const _hoisted_2 = { class: "breadcrumb-item" };
const _hoisted_3 = {
    key: 0,
    class: "breadcrumb-current"
};
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { buildBreadcrumbs, getHomeRoute } from '@/utils/redirects';
import { userCanViewStudentLogs } from '@/utils/profileHelpers';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BreadcrumbNav',
    setup(__props) {
        const route = useRoute();
        const store = useStore();
        const profileRoutes = ['Profile View', 'Profile Settings'];
        const homeRoute = computed(() => getHomeRoute(store));
        const breadcrumbs = computed(() => buildBreadcrumbs(route, store));
        const profileSettingsSection = computed(() => store.getters.getProfileSettingsSection);
        const isProfileRoute = computed(() => profileRoutes.includes(route.name));
        const isAvatarSection = computed(() => route.name === 'Profile Settings' && profileSettingsSection.value === 'customizeAvatarSection');
        const isWideProfileRoute = computed(() => Boolean(route.name === 'Profile View'
            && userCanViewStudentLogs(store.getters.getType, store.getters.getProfileRole)));
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (breadcrumbs.value.length > 0)
                ? (_openBlock(), _createElementBlock("nav", {
                    key: 0,
                    "aria-label": "breadcrumb",
                    class: _normalizeClass(['breadcrumb-nav', {
                            'breadcrumb-nav--profile': isProfileRoute.value && !isAvatarSection.value,
                            'breadcrumb-nav--profile-wide': isWideProfileRoute.value,
                            'breadcrumb-nav--avatar': isAvatarSection.value
                        }])
                }, [
                    _createElementVNode("ol", _hoisted_1, [
                        _createElementVNode("li", _hoisted_2, [
                            _createVNode(_component_router_link, {
                                to: homeRoute.value,
                                class: "breadcrumb-link"
                            }, {
                                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                        _createTextVNode(" Início ", -1)
                                    ]))]),
                                _: 1
                            }, 8, ["to"])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbs.value, (crumb, idx) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: idx,
                                class: _normalizeClass(['breadcrumb-item', { active: idx === breadcrumbs.value.length - 1 }])
                            }, [
                                (idx === breadcrumbs.value.length - 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(crumb.label), 1))
                                    : (_openBlock(), _createBlock(_component_router_link, {
                                        key: 1,
                                        to: crumb.to,
                                        class: "breadcrumb-link"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(crumb.label), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["to"]))
                            ], 2));
                        }), 128))
                    ])
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
